import { Snackbar } from '@mui/material';
import React, { useState } from 'react';
import { useImportCsv } from '../../services/react-query/import/useImportCsv';
import { ITableConfigurableModules } from '../../types/Itable';
import ImportModal from './ImportModal';
import VerifyImportModal, { RowError } from './VerifyImportModal';
import _ from 'lodash';

interface Props {
  module: ITableConfigurableModules;
  templateUrl: string;
  open: boolean;
  onCloseRequest: () => void;
}

export default function ImportAndVerifyContainer({ module, templateUrl, open, onCloseRequest }: Props) {
  const [verifyOpen, setVerifyOpen] = useState(false);
  const [errors, setErrors] = useState<RowError[]>([]);
  const [importKey, setImportKey] = useState(0);
  const [saved, setSaved] = useState(false);

  const { mutate: importCsv, isPending } = useImportCsv({
    onSuccess: () => {
      setSaved(true);
      onCloseRequest();
    },
    onRowErrors: (rowErrors) => {
      setErrors(rowErrors);
      setVerifyOpen(true);
    },
  });

  const handleUpload = (fileBase64: string) => {
    importCsv({ module, fileBase64 });
  };

  const handleUploadNewFile = () => {
    setVerifyOpen(false);
    setErrors([]);
    setImportKey((k) => k + 1);
  };

  return (
    <>
      <ImportModal
        key={importKey}
        open={open && !verifyOpen}
        onClose={onCloseRequest}
        templateUrl={templateUrl}
        module={module}
        onUpload={handleUpload}
        processing={isPending}
      />

      <VerifyImportModal open={verifyOpen} errors={errors} onClose={() => setVerifyOpen(false)} onUploadNewFile={handleUploadNewFile} />

      <Snackbar open={saved} onClose={() => setSaved(false)} message={`${_.startCase(module)} imported successfully!`} />
    </>
  );
}
